import React, { useState } from 'react'
import TreatmentListContent from './TreatmentListContent';
import TreatmentSlider from '../Sliders/TreatmentSlider';
import { FiLink2 } from 'react-icons/fi';

const TreatmentItem = (props) => {
  const treatmentId = props.tratamiento.title.replace(/ /g, '-');
  const [linkCopied, setLinkCopied] = useState(false);

  const copyTreatmentLink = async () => {
    const treatmentLink = `${window.location.origin}${window.location.pathname}#${treatmentId}`;

    try {
      await navigator.clipboard.writeText(treatmentLink);
    } catch (error) {
      const linkInput = document.createElement('input');
      linkInput.value = treatmentLink;
      document.body.appendChild(linkInput);
      linkInput.select();
      document.execCommand('copy');
      document.body.removeChild(linkInput);
    }

    setLinkCopied(true);
    window.setTimeout(() => setLinkCopied(false), 2000);
  };

  return (
    <article className='treatment-item' id={treatmentId}>
      <TreatmentSlider arrayImages={props.tratamiento.images} />

      <div className='treatment-item-content'>
        <div className='treatment-item-title'>
          <div className='copy-treatment-container'>
            <button
              type='button'
              className='copy-treatment-link'
              onClick={copyTreatmentLink}
              aria-label={linkCopied ? 'Enlace copiado' : `Copiar enlace de ${props.tratamiento.title}`}
              title={linkCopied ? 'Enlace copiado' : 'Copiar enlace del tratamiento'}
            >
              <FiLink2 aria-hidden='true' />
            </button>
            {linkCopied && <span className='copy-treatment-link-message' role='status'>Enlace copiado</span>}
          </div>

          <h2>{props.tratamiento.title}</h2>
        </div>
        {props.tratamiento.contents.sort((a, b) => a.position > b.position ? 1 : -1).map((item, index) => (
          <div key={index} >{Array.isArray(item.content) ? <TreatmentListContent arrayList={item.content} /> : item.content}</div>
        ))}
      </div>
    </article>
  )
}

export default TreatmentItem